"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Day;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _colors = require("HubStyleTokens/colors");

var _sizes = require("HubStyleTokens/sizes");

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _UITooltip = _interopRequireDefault(require("../../tooltip/UITooltip"));

var _Styles = require("../../utils/Styles");

var todayDotMixin = (0, _styledComponents.css)(["::before{content:' ';display:inline-block;position:absolute;border:2.5px solid currentColor;border-radius:50%;top:22px;left:16px;}"]);
var disabledMixin = (0, _styledComponents.css)(["::after{content:' ';display:inline-block;position:absolute;top:12px;bottom:0;left:2px;right:13px;border-top:1px solid currentColor;transform:rotate(45deg);}"]);

var Cell = _styledComponents.default.td.withConfig({
  displayName: "Day__Cell",
  componentId: "sc-1sul5rl-0"
})(["position:relative;height:30px;padding:0;cursor:", ";color:", ";background-color:", ";border-radius:", ";", ";", " ", " &:hover{background-color:", ";}"], function (_ref) {
  var isDisabled = _ref.isDisabled;
  return isDisabled ? 'not-allowed' : 'pointer';
}, function (_ref2) {
  var isDisabled = _ref2.isDisabled,
      isSelected = _ref2.isSelected,
      isToday = _ref2.isToday,
      isCurrentMonth = _ref2.isCurrentMonth;
  if (isSelected) return _colors.OLAF;
  if (isDisabled || !isCurrentMonth) return _colors.BATTLESHIP;
  if (isToday) return _colors.SORBET_DARK;
  return null;
}, function (_ref3) {
  var isDisabled = _ref3.isDisabled,
      isInRange = _ref3.isInRange,
      isSelected = _ref3.isSelected;
  if (isDisabled) return null;
  if (isSelected) return _colors.CALYPSO;
  if (isInRange) return _colors.CALYPSO_LIGHT;
  return null;
}, function (_ref4) {
  var isInRange = _ref4.isInRange,
      isRangeStart = _ref4.isRangeStart,
      isRangeEnd = _ref4.isRangeEnd;
  if (isInRange) return null;
  if (isRangeStart && isRangeEnd) return _sizes.BUTTON_RADIUS;
  if (isRangeStart) return _sizes.BUTTON_RADIUS + " 0 0 " + _sizes.BUTTON_RADIUS;
  if (isRangeEnd) return "0 " + _sizes.BUTTON_RADIUS + " " + _sizes.BUTTON_RADIUS + " 0";
  return _sizes.BUTTON_RADIUS;
}, function (_ref5) {
  var isSelected = _ref5.isSelected,
      isToday = _ref5.isToday;
  return isSelected || isToday ? _Styles.FONT_FAMILIES.demibold : _Styles.FONT_FAMILIES.medium;
}, function (_ref6) {
  var isToday = _ref6.isToday;
  return isToday && todayDotMixin;
}, function (_ref7) {
  var isDisabled = _ref7.isDisabled;
  return isDisabled && disabledMixin;
}, function (_ref8) {
  var isDisabled = _ref8.isDisabled,
      isInRange = _ref8.isInRange,
      isSelected = _ref8.isSelected;
  return !isDisabled && !isSelected && (isInRange ? _colors.CALYPSO_MEDIUM : _colors.CALYPSO_LIGHT);
});

function Day(props) {
  var tooltip = props.tooltip,
      tooltipOpen = props.tooltipOpen,
      rest = (0, _objectWithoutProperties2.default)(props, ["tooltip", "tooltipOpen"]);
  return _react.default.createElement(_UITooltip.default, {
    "aria-live": "polite",
    open: tooltipOpen,
    title: tooltip
  }, _react.default.createElement(Cell, rest));
}

Day.displayName = 'Day';
module.exports = exports.default;